import React, { useRef, useCallback, useEffect } from 'react'
import { CardSliderHotArea } from '@/components'
export default function Preview({
    baseConfig,
    rectOptions,
    props,
    zIndex = 0,
    onChange = () => {}
}) {
    const { width, height, left, top } = rectOptions
    const { bannerWidth, between, interval, banners } = props
    const timer = useRef(null)
    const stopAutoScroll = useCallback(() => {
        clearInterval(timer.current)
    }, [timer])
    useEffect(() => {
        return stopAutoScroll
    }, [])

    return (
        <div
            style={{
                position: 'absolute',
                width,
                height,
                top: 0,
                left: 0,
                zIndex,
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    width,
                    height,
                    left,
                    top,
                    overflow: 'hidden',
                }}
            >
                <CardSliderHotArea
                    banners={banners}
                    wrapWidth={width}
                    between={between}
                    interval={interval}
                    bannerRect={{
                        width: bannerWidth,
                        height: height
                    }}
                    onChange={(index) => {
                        onChange(index)
                    }}
                />

            </div>
        </div>
    )
}